import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30db3e27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }

import {computed} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import _ from "lodash";
import NumberTable from "./NumberTable.vue";
import {NumberFieldType} from "@/components/business/crud/interface/FieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const value = computed({
  get() {
    return data.value[props.propName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.propName] = val.toString();
    } else {
      data.value[props.propName] = val;
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_input_number, {
      placeholder: '请填写' + _ctx.info.title,
      precision: _ctx.widget.scale,
      value: value.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      style: {"width":"100%"}
    }, null, 8, ["placeholder", "precision", "value"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(NumberTable, _mergeProps({ data: _unref(data) }, _ctx.$props), null, 16, ["data"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})